import userId from '../../lib/user-id'

export const namespace = 'Log'

export default {
    namespaced: true,

    namespace,

    state: {
        displays: [],
        sessions: {},
    },

    mutations: {
        logDisplay(state, { ruleId }) {
            const sessionId = window.addiesaas.store.getters['Marketing/CartRules/Session/session']
            state.displays.push({
                userId: userId(),
                sessionId,
                ruleId,
                date: (new Date()).toJSON(),
            })
        },
        logSession(state) {
            const id = window.addiesaas.store.getters['Marketing/CartRules/Session/session']
            const session = state.sessions[id] || {
                id,
                userId: userId(),
                start: (new Date()).toJSON(),
            }
            session.end = (new Date()).toJSON()
            state.sessions[id] = session
        },
    },

    actions: {
        logDisplay({ commit }, payload) {
            commit('logDisplay', payload)
        },
        logSession({ commit }) {
            commit('logSession')
        },
    },

    getters: {
        displays: state => state.displays,
        sessions: state => state.sessions,
    },
}
